module.exports = "dist/376c1f97f6553dea1ca9b3f9081889bd.svg";